// extracted by mini-css-extract-plugin
export default {"imageContainer":"ProductImage_imageContainer__vwosz"};